/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const rankingsListData = {
  transactionsData: [
    {
      color: "success",
      icon: "arrow_upward",
      name: "Software per la crescita aziendale",
      description: "Numero impression nel periodo selezionato: 2500",
      value: "154 Click",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Qlickup software",
      description: "Numero impression nel periodo selezionato: 3500",
      value: "103 Click",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Gestisci marketing con software",
      description: "Numero impression nel periodo selezionato: 912",
      value: "11 Click",
    },
  ],

  revenueData: [
    {
      color: "success",
      icon: "arrow_upward",
      name: "via PayPal",
      description: "07 June 2021, at 09:00 AM",
      value: "+ $ 4,999",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Partner #90211",
      description: "07 June 2021, at 05:50 AM",
      value: "+ $ 700",
    },
    {
      color: "error",
      icon: "arrow_downward",
      name: "Services",
      description: "07 June 2021, at 07:10 PM",
      value: "- $ 1,800",
    },
  ],
};

export default rankingsListData;
